<template>
  <div class="text mb-sm">
    <slot name="close"></slot>
    <label class="ml" v-if="data">{{ data.title }} <span v-if="data.require" class="text-danger">*</span></label>
    <span class="pull-right text-muted">{{ data.placeholder }}<i class="icon el-icon-arrow-right pull-right ml-xs" /></span>
  </div>
</template>
<script>
export default {
  name: 'SelectorPreview',
  props: {
    data: Object
  }
}
</script>
<style lang='scss' scoped>
.text {
  font-size: 14px;
  padding: 12px 15px;
  white-space: pre-line;
  word-break: break-all;
  word-wrap: break-word;
  overflow: hidden;
  background-color: #fafafa;
  .icon {
    height: 20px;
    line-height: 20px;
  }
}
</style>
